import Button from "../../elements/CustomButton/CustomButton";
import Card from "../Card/Card";
// import { Button } from "react-bootstrap";
import { ContentLogoCard } from "../Uploader/ContentLogoCard";
import { FormattedMessage } from "react-intl";
import React from "react";
import S3Uploader from "../Uploader/DropzoneUploader";
// import { EmptyAddAttachmentCard } from "../Uploader/EmptyAddAttachmentCard";



const BankImportUploader = ({ onImportDone, path, sendNotification }) => {
  const s3Path = path;

  const ImportCard = () => {
    return (
      <Card
        title={
          <span>
            <FormattedMessage id="ids_uploadCSVFile" />
          </span>
        }
        textCenter={true}
        ftTextCenter={true}
        stats={
          <Button wd block>
            <i className="fa fa-2x fa-plus-circle" />
          </Button>
        }
      />
    );
  };

  return (
    <div style={{}}>
      <S3Uploader
        accept = {"text/csv,application/vnd.ms-excel"}
        EmptyComponent={ImportCard}
        ContentComponent={ContentLogoCard}
        s3path={s3Path}
        onFinish={values => onImportDone(values)}
        sendNotification={sendNotification}
      />
    </div>
  );
};

export default BankImportUploader;
